/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
var utils = require('../utils/trip_type');

(function() {
    'use strict';
    var instance;
    var validator = new (require('../validator'))();
    var SearchModel = Odigeo.Model.extend({
        defaults: {
            newRoomFormat: true,
        },
        clear: function() {
            var result = Odigeo.Model.prototype.clear.call(this, {silent: true});
            this.set(this.defaults, {silent: true});
            this.trigger('clear', {searchModelSilent: true});

            return result;
        },

        set: function() {
            var response = Odigeo.Model.prototype.set.apply(this, arguments);
            this.validation();
            return response;
        },

        fetch: function(attrs) {
            this.set(attrs, {silent: true});
            this.trigger('sync:fetch', {searchModelSilent: true});

            return $.Deferred().resolve().promise();
        },

        validation: function(options) {
            /* jshint maxcomplexity: 8, maxstatements: 15 */
            var errors = [];
            var attrs = this.toJSON();
            var searchSegments = attrs.searchSegments;
            var depDateString;
            var arrDateString;
            var isDpSearch;
            var isAccommodationSearch;
            const isTrainAgeFlow = Odigeo.SessionScope.trainAgeEnabled && attrs.trainSearch;

            validator.resetConfig();
            validator.setConfig(options);
            errors = errors.concat(validator.validateSegmentsLength(searchSegments));
            isDpSearch = !Odigeo._.isEmpty(validator.config.searchType) && Odigeo._.isEqual(validator.config.searchType, 'dpSearch');
            isAccommodationSearch =
                (!Odigeo._.isEmpty(validator.config.searchType) && Odigeo._.isEqual(validator.config.searchType, 'accommodationSearch')) ||
                (!Odigeo._.isEmpty(searchSegments) &&
                    !Odigeo._.isEmpty(searchSegments.type) &&
                    Odigeo._.contains(searchSegments.type, 'accommodation'));

            if (Odigeo._.isEmpty(errors)) {
                depDateString = Odigeo._.result(searchSegments[0], 'dateStr');
                arrDateString = Odigeo._.result(searchSegments[1], 'dateStr');
                if (isTrainAgeFlow) {
                    const adultAges = attrs.adultAges ? attrs.adultAges.split('-') : [];
                    const childrenAges = attrs.childrenAges ? attrs.childrenAges.split('-') : [];
                    const infantAges = attrs.infantAges ? attrs.infantAges.split('-') : [];
                    errors = errors.concat(
                        validator.validateFlighType(attrs.type),
                        validator.validateSegmentsLengthAndFlightType(searchSegments, attrs.type),
                        validator.validateSegmentsContent(searchSegments, attrs.type, isAccommodationSearch),
                        validator.validateAccommodationDestination(attrs.accommodationDestination, isAccommodationSearch),
                        validator.validateTrainPassengers(attrs.numAdults, attrs.numChildren, attrs.numInfants, adultAges, childrenAges, infantAges),
                        validator.validateRoomChildrenAges(attrs.rooms, 'childrenAges'),
                        validator.validateCabinClass(attrs.cabinClass),
                        validator.validateCalendarIncomplete(searchSegments, attrs.type),
                        validator.validateCalendarOutdate(depDateString)
                    );
                } else {
                    errors = errors.concat(
                        validator.validateFlighType(attrs.type),
                        validator.validateSegmentsLengthAndFlightType(searchSegments, attrs.type),
                        validator.validateSegmentsContent(searchSegments, attrs.type, isAccommodationSearch),
                        validator.validateAccommodationDestination(attrs.accommodationDestination, isAccommodationSearch),
                        validator.validatePassengers(attrs.numAdults, attrs.numChildren, attrs.numInfants),
                        validator.validateRoomChildrenAges(attrs.rooms, 'childrenAges'),
                        validator.validateCabinClass(attrs.cabinClass),
                        validator.validateCalendarIncomplete(searchSegments, attrs.type),
                        validator.validateCalendarOutdate(depDateString)
                    );
                }

                if (Odigeo._.has(attrs, 'checkInDate') || Odigeo._.has(attrs, 'checkOutDate') || isDpSearch) {
                    errors = Odigeo._.every([attrs.checkInDate, attrs.checkInDate], validator.isDate) ?
                        errors.concat(validator.validateCheckinDatesLength(attrs.checkInDate, attrs.checkOutDate)) :
                        errors.concat(validator.validateCheckinDatesLength(depDateString, arrDateString, 'date'));
                }

                if (isAccommodationSearch && (Odigeo._.has(attrs, 'checkInDate') || Odigeo._.has(attrs, 'checkOutDate'))) {
                    errors = errors.concat(
                        validator.validateCheckInCalendarIncomplete(attrs.checkInDate, attrs.checkOutDate)
                    );
                }
            }

            this.trigger('errors', errors, validator.config);

            return errors;
        },

        isSingleFlight: function() {
            return utils.isOneWayOrRoundTrip(this.get('type'));
        },

        hasSearchData: function() {
            return !Odigeo._.isEmpty(Odigeo._.omit(this.toJSON(), Odigeo._.keys(this.defaults)));
        },

        getDates: function() {
            return Odigeo._.map(this.get('searchSegments'), function(segment) {
                return segment.dateStr ? Odigeo.Utils.parseDate(segment.dateStr) : null;
            });
        },
    });

    module.exports.SearchModelClass = SearchModel;
    module.exports.getInstance = function() {
        if (Odigeo._.isUndefined(instance)) {
            instance = new SearchModel();
        }

        return instance;
    };
}());
